import { render, staticRenderFns } from "./SimpleHeader.vue?vue&type=template&id=dadfcf6c&scoped=true"
import script from "./SimpleHeader.vue?vue&type=script&lang=js"
export * from "./SimpleHeader.vue?vue&type=script&lang=js"
import style0 from "./SimpleHeader.vue?vue&type=style&index=0&id=dadfcf6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dadfcf6c",
  null
  
)

export default component.exports